<template>
  <div :class="clsx('awards-wrapper', { 'animations-disabled': !animationEnabled })" id="awards">
    <IntersectionObserver
      class="awards-intersector"
      :animation-enabled="animationEnabled"
      :once="true"
      once-class="awards-intersector--visible"
      :threshold="0.3"
    >
      <div class="awards__title-block">
        <h2 class="awards__title" v-html="getTitleBlock('promo', 'awards', 'title')"></h2>
        <p class="awards__description" v-html="getTitleBlock('promo', 'awards', 'description')"></p>
      </div>
      <div class="awards__list">
        <ul class="awards-list">
          <li class="awards-list-item">
            <a
              :class="clsx('awards-list-item__link', { 'awards-list-item__link--clicked': ukrainianBanksAssociationAwardClicked })"
              @click="() => awardClick('ukrainianBanksAssociationAward')"
            >
              <UkrainianBanksAssociationAward class="awards-list-item__award" />
              <div class="awards-list-item__title-block">
                <h3 class="awards-list-item__title">Insurtech-прорив року</h3>
                <p class="awards-list-item__description">від Асоціації українських банків</p>
              </div>
            </a>
          </li>
          <li class="awards-list-item">
            <a
              :class="clsx('awards-list-item__link', { 'awards-list-item__link--clicked': bankerAwardClicked })"
              @click="() => awardClick('bankerAward')"
            >
              <BankerAwards class="awards-list-item__award" />
            <div class="awards-list-item__title-block">
              <h3 class="awards-list-item__title">Insurtech-прорив року</h3>
              <p class="awards-list-item__description">від Banker Awards’25</p>
            </div>
            </a>
          </li>
        </ul>
        <div class="transparent-background"></div>
      </div>
    </IntersectionObserver>
  </div>
</template>

<script>
import clsx from 'clsx';
import { mapGetters } from 'vuex';
import BankerAwards from './banker-awards';
import UkrainianBanksAssociationAward from './ukrainian-banks-association';
import { textBlock } from '@/entities/text-block';
import { IntersectionObserver } from '@/shared/ui/intersection-observer';

export default {
  props: {
    animationEnabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      ukrainianBanksAssociationAwardClicked: false,
      bankerAwardClicked: false,
    };
  },
  mixins: [ textBlock ],
  components: { IntersectionObserver, BankerAwards, UkrainianBanksAssociationAward },
  computed: {
    ...mapGetters('layoutModule', ['isTouchDevice']),
  },
  methods: {
    clsx,
    awardClick(name) {
      this.ukrainianBanksAssociationAwardClicked = name === 'ukrainianBanksAssociationAward';
      this.bankerAwardClicked = !this.ukrainianBanksAssociationAwardClicked;
    },
  }
};
</script>

<style lang="scss" scoped>
.awards {
  &__title-block {
    margin-top: 72px;

    @media (max-width: 600px) {
      margin-top: 40px;
    }
  }

  &__title {
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 52px;
    font-weight: 500;
    color: #313437;
    text-align: center;
    margin-bottom: 16px;
    transform: translateY(100%);
    opacity: 0;
    animation: slideup-text-animation 0.5s linear forwards;
    animation-play-state: paused;

    @media (max-width: 600px) {
      font-size: 46px;
    }
  }

  &__description {
    font-size: 18px;
    font-weight: 400;
    color: #494E53;
    text-align: center;
    transform: translateY(100%);
    opacity: 0;
    animation: slideup-text-animation 0.5s linear forwards;
    animation-delay: 0.5s;
    animation-play-state: paused;
  }

  &__list {
    position: relative;
  }
}

.awards-list {
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 950px) {
    flex-direction: column;
  }

  &-item {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    transform: scale(0.5);
    opacity: 0;
    animation: award-animation 0.5s linear forwards;
    animation-delay: 1s;
    animation-play-state: paused;

    &__title-block {
      position: absolute;
      bottom: 30px;
      left: 50%;
      width: 100%;
      transform: translateX(-50%);
    }

    &__title {
      font-family: "IBM Plex Sans", sans-serif;
      font-size: 28px;
      font-weight: 500;
      text-align: center;
      color: #313437;
    }

    &__description {
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      color: #494E53;
    }

    &__link {
      .awards-list-item__award {
        transform: scale(1.2);
        transition: transform 0.5s;
      }

      .awards-list-item__title-block {
        transition: bottom 0.5s;
      }

      &:hover, &--clicked {
        .awards-list-item__award {
          transform: scale(2);
        }

        .awards-list-item__title-block {
          bottom: -5px;
        }
      }
    }
  }
}

.transparent-background {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 20px;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
}

.awards-intersector {
  &--visible {
    .awards__title,
    .awards__description,
    .awards-list-item {
      animation-play-state: running;
    }
  }
}

.animations-disabled,
.animations-disabled * {
  animation: none !important;
  animation-duration: 0s !important;
  animation-delay: 0s !important;
  transition: none !important;
}

.animations-disabled {
  .awards {
    &__title, &__description {
      transform: translateY(0);
      opacity: 1;
    }
  }

  .awards-list, .awards-list-item, .awards-list-item__title, .awards-list-item__description {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes slideup-text-animation {
  0% {
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 0%, 0 0%);
    transform: translateY(100%);
  }
  20% {
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 20%, 0 20%);
    transform: translateY(80%);
  }
  40% {
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 40%, 0 40%);
    transform: translateY(60%);
  }
  60% {
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 60%, 0 60%);
    transform: translateY(40%);
  }
  80% {
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 80%, 0 80%);
    transform: translateY(20%);
  }
  100% {
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
    transform: translateY(0);
  }
}

@keyframes award-animation {
  from {
    transform: scale(0.5);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
